/* SLIDE 13 */

import React, { useEffect, useRef, useState } from 'react';
import ButtonBot from "shared/components/ButtonBot";
// import cameraIcon from "assets/icons/cameraIcon.svg";
import AppInfoRow from 'shared/components/AppInfoRow';
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { replaceImageLink, makeCenterLine, makeFixedLine } from 'utils/common';
import { onGetParkingTid } from "../utils/parkingUtils";
import { setAppLoading } from '../../../shared/store/headerSlice';
import { toast } from "react-toastify";
import { DateTime } from 'luxon';
import { datetimeFormat } from '../../../utils/common';
import ImageViewPopup from '../../../shared/components/ImageViewPopup';
import imageNotFound from "assets/images/imageNotFound.png";
import Skeleton from 'react-loading-skeleton';

function ParkingCheckSuccess() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { selectedSpotState } = location.state || {};
    const { selectedSpot, parkingName } = useSelector((state) => state.parking);
    const { user } = useSelector((state) => state.auth);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [loading, setLoading] = useState(1);
    const [isImageScrolled, setIsImageScrolled] = useState(false);

    const carImage = selectedSpot?.inImageLink ? window.location.hostname?.includes('mobilesongpagongdanpark2.or.kr') ? encodeURI(replaceImageLink(selectedSpot?.inImageLink)) : replaceImageLink(selectedSpot?.inImageLink) : imageNotFound;
    // console.log("Selected Spot:", user);
    // console.log("Selected Spot:", selectedSpot);

    const handleImageError = (e) => {
        console.error("Image failed to load:", e.target.src);
        e.target.onerror = null; // Prevent looping
        e.target.style.height = '100%';
        e.target.style.objectFit = 'contain'; // Placeholder image
        e.target.src = imageNotFound; // Placeholder image
    }

    useEffect(() => {

        // window.addEventListener('message', responseHandler);       // for Iphone
        document.addEventListener('message', handlePaymentResponse);  // for Android
        return () => document.removeEventListener('message', handlePaymentResponse);
    }, []);

    const handlePaymentResponse = (event) => {
        const msg = JSON.parse(event.data);
        // alert(JSON.stringify(msg));
        try {
            if (msg.type === 'printRes') {
                if (['0000', '0021'].includes(msg.body.responseCode)) {
                    // when print success
                    dispatch(setAppLoading(false));
                    toast.success('성공했습니다.', {
                        position: "top-center",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        className: 'htToastSuccess',
                    });
                }
            }

            else if (msg.type === 'notInstalled') {
                //   dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: true } });
                //   setLoadingPayment(false);
                dispatch(setAppLoading(false));
            }
        } catch (e) {
            alert(e.message);
            console.error('Fail to parse message:', e);
        }
    };

    // Handle print form
    const sendEvidencePaper = async () => {
        try {

            const encoder = new TextEncoder(); // 기본 utf-8

            const form = [
                0x1B, 0x40, //명령 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeCenterLine('[ 입 차 증 ]', true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('구획번호:', selectedSpot?.spaceNumber, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('차량번호:', selectedSpot?.carNum, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeFixedLine('관리자번호:', user?.mobilePhone, true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode(makeFixedLine('입차시간:', DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("yyyy-MM-dd HH:mm"))), 0x0A,
                ...encoder.encode(makeFixedLine('주차장소:', user?.parking?.parkingName)), 0x0A,
                ...encoder.encode(makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')), 0x0A,
                ...encoder.encode(makeFixedLine('주차문의:', user?.parking?.phoneNumber,)), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(2) + '근무자 휴식시간 안내'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('* 현장근무자 휴식시간 및 전화가 꺼져있는 경우'), 0x0A,
                ...encoder.encode('하단 관리자번호로 차량번호 필수 작성 후 문자 보내주세요.'), 0x0A,
                ...encoder.encode('* 주차요금 계좌번호 등 문자 전송해 드립니다.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(3) + '미납요금 납부방법'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('송파구시설관리공단 공영주차부 홈페이지'), 0x0A,
                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('(www.songpagongdanpark2.or.kr)'),
                0x1D, 0x21, 0x00,   // 크기 초기화
                ...encoder.encode(' 미납요금 조회 및 요금을 납부하실 수 있습니다.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(' '.repeat(8) + '결제문의'), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                ...encoder.encode('주차관리자:' + user?.parking?.administrator), 0x0A,
                ...encoder.encode('관리자번호:' + user?.mobilePhone), 0x0A,
                ...encoder.encode('* 전화기가 꺼져있을 경우 문자 남겨주세요.'), 0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode('-'.repeat(24)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
                0x0A,

                0x1D, 0x21, 0x11,   // 크기 크게
                ...encoder.encode(makeCenterLine('송파구시설관리공단', true)), 0x0A,
                0x1D, 0x21, 0x00,   // 크기 초기화
            ];

            const formData = new Uint8Array(form);

            const formEnc = btoa(String.fromCharCode(...formData));

            const payKey = await onGetParkingTid(user.parkingId, selectedSpot.entryId);

            if (!payKey || !payKey.tid) {
                // console.log('no tid');
                return;
            }

            // print params for VAN API
            const params = new URLSearchParams({
                billType: '9',                                  // 전문종류 ( 9:프린터출력 )
                terminalNo: payKey?.tid,                        // 단말기 번호
                // orderKey: payKey?.parkingEntryId || '99999',    // 주문번호
                orderKey: '99999',
                printResType: '1',
                resScheme: 'innodep://printResponse',           // 응답 스키마
            });

            if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "print", body: params.toString(), printForm: formEnc })
                );
            } else {
                // setLoadingPayment(false);
                console.error('Cannot find Native App !!');
            }

        } catch (error) {
            console.error('Printing failed:', error);
            dispatch(setAppLoading(false));
        } finally {
            dispatch(setAppLoading(false));
        }
    }
    const containerRef = useRef(null);
    useEffect(() => {
        if (containerRef.current) {
            const img = containerRef.current.querySelector('img');
            // Handle image loading errors
            img.onerror = () => {
                clearInterval(interval);
            };
            // Check immediately if the image has loaded
            if (img.naturalWidth > 0 && img.naturalHeight > 0) {
                // Calculate 75% of the scroll height
                const scrollPosition = (img.naturalHeight - 185) * 0.5 - 30;
                containerRef.current.scrollTo({
                    top: scrollPosition,
                });
                setTimeout(() => {
                   setIsImageScrolled(true);
                }, 100);

                // console.log(scrollPosition);
                return;
            }
            // Periodically check if image is not loaded
            const interval = setInterval(() => {
                if (img.naturalWidth > 0 && img.naturalHeight > 0) {
                    // Calculate 75% of the scroll height
                    const scrollPosition = (img.naturalHeight - 185) * 0.5 - 30;
                    containerRef.current.scrollTo({
                        top: scrollPosition,
                    });
                    setTimeout(() => {
                        setIsImageScrolled(true);
                    }, 100);
                    // console.log(img.naturalHeight);
                    // console.log(2);
                    clearInterval(interval);
                }
            }, 100);

            const loadingInterval = setInterval(() => {
                setLoading(prev => prev + 1);
            }, 300);

            // Clean up when component unmounts
            return () => {
                clearInterval(interval);
                clearInterval(loadingInterval);
            }
        } else {
            const loadingInterval = setInterval(() => {
                setLoading(prev => prev + 1);
            }, 300);
            // Clean up when component unmounts
            return () => {
                clearInterval(loadingInterval);
            }
        }

    }, []);

    return (


        <>
            {/* {loading == 1 && <div style={loading == 1 ? { opacity: 1} : { display: 'none' }}>
                <ParkingCheckSuccessSkeleton />
            </div>} */}
            <div className="htContainer"
                // style={loading != 1 ? { opacity: 1 } : { opacity: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            >
                <div className="sub-header justify-center">
                    <div
                        className={`sub-header-text w-full`}
                    >

                        <span className="htColorGray2">주차장명 : </span>
                        <span className="htBold">{`${user?.parking?.parkingName} (${user?.parkingId})`}</span>

                    </div>
                </div>
                <div className="htContent htHasButtonBot mt-20">
                    <div className="htCarImage" onClick={() => setIsPopupOpen(true)}>
                        <div ref={containerRef} className="nl-image-license-plate">
                            <img
                                src={carImage}
                                alt="Car"
                                onError={handleImageError}
                                style={{opacity: !isImageScrolled ? 0 : 1}}
                            />
                        </div>
                    </div>


                    <div className="htTextField">
                        <label className="htLabel htBold">입차정보</label>
                        <span></span>
                    </div>
                    <AppInfoRow label="차량번호" value={selectedSpot?.carNum} valueClass={"htBold"} />
                    <AppInfoRow label="입차일시" value={datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm")} valueClass={"htBold"} />
                    {selectedSpot?.outTime && <AppInfoRow label="예상 출차 시간" value={datetimeFormat(selectedSpot?.outTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm")} valueClass={"htBold"} />}

                    {/* <AppInfoRow label="주차구분" value="일반반(사각간)" /> */}

                    <div className="htSeparator"></div>
                    {/* <button className="htCameraButton mt-20" onClick={() => {
                    navigate("/parking_check");
                }}>
                    <span className="htCameraIcon">
                        <img src={cameraIcon} alt="Camera" />
                    </span>
                    <span className="htRetakeText">재촬영</span>
                </button> */}
                    <button className="htSubmitButton" onClick={() => {
                        dispatch(setAppLoading(true));
                        sendEvidencePaper();
                    }} style={{ fontWeight: "400" }}>입차증 재발급</button>
                    <ButtonBot textYes={selectedSpot?.outTime ? (selectedSpot?.payStatusCd == '020' ? '결제완료' : '미납처리됨') : `출차`} handleYes={() => navigate("/parking_payment")} disable={selectedSpot?.outTime} />
                </div>
            </div>

            {isPopupOpen && (
                <ImageViewPopup
                    imageSrc={carImage}
                    onClose={() => {
                        setIsPopupOpen(false);
                        setZoomLevel(1);
                    }}
                    zoomLevel={zoomLevel}
                    setZoomLevel={setZoomLevel}
                />
            )}

        </>

    );
}

export default ParkingCheckSuccess;

function ParkingCheckSuccessSkeleton() {
    const rowCount = 12;
    const columnCount = 4;
    return (
        <div style={{ padding: '20px' }}>
            <Skeleton height={40} width="100%" style={{ marginBottom: '20px' }} />

            <div style={{ marginBottom: '10px' }}>
                <Skeleton height={185} width="100%" />
            </div>

            <div className="htSection">
                <h2>입차정보</h2>
                <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={80} height={20} /></div>
                <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={120} height={20} /></div>
            </div>
        </div>
    );
}
